define(["mw-remote/serviceRegistryLookup","/local/buildagent/work/71550ad6d48e14da/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "", __webpack_require__.dj.c(), true);
});